import { format, isValid, parseISO } from 'date-fns';
import { ptBR } from 'date-fns/locale';

function parseDate(value) {
  if (!value) return null;
  const parsed = typeof value === 'string' ? parseISO(value) : new Date(value);
  return isValid(parsed) ? parsed : null;
}

export function formatDate(value, formatStr = 'dd/MM/yyyy') {
  const parsed = parseDate(value);
  if (!parsed) return '-';
  return format(parsed, formatStr);
}

export function formatDateTime(value, formatStr = 'dd/MM/yyyy HH:mm') {
  return formatDate(value, formatStr);
}

/**
 * Formats a date as "18 de Outubro de 2026" (month capitalized).
 */
export function formatDateLong(value) {
  const parsed = parseDate(value);
  if (!parsed) return '-';
  const formatted = format(parsed, "d 'de' MMMM 'de' yyyy", { locale: ptBR });
  return formatted.replace(/ de (\p{L})/u, (_, letter) => ` de ${letter.toUpperCase()}`);
}
